import React from 'react';
import { GButton } from '@gamiphy/loyalty-station-desktop/uikit';
import { useTranslation } from '@gamiphy/react-i18n';

const SurveyButton: React.FC<{
    isSubmit: boolean,
    isDisabled: boolean,
    isLoading: boolean,
}> = ({
  isSubmit,
  isDisabled,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <GButton
      color="primary"
      variant="contained"
      type="submit"
      fullWidth
      loading={isLoading}
      disabled={isDisabled}
    >
      {isSubmit
        ? t('survey.submit', { defaultValue: 'Submit' })
        : t('continue', 'Continue')}
    </GButton>
  );
};

export default SurveyButton;
